import React from 'react';
import { EditableModel, useEditry } from '@lazylabs-dev/editry-react';
import { getCurrentLanguage } from '../utils/languageSwitcher';

const LANGUAGE_BY_LOCALE = {
  'cs-CZ': 'cs',
  'sk-SK': 'sk',
  'pl-PL': 'pl',
  'hu-HU': 'hu'
};

function languageOf(item) {
  if (item?.language) {
    return item.language;
  }
  return LANGUAGE_BY_LOCALE[getCurrentLanguage()] || 'cs';
}

export default function EditableField({ model, item, field, as = 'span', className, children }) {
  const { overlayEnabled, adminSession } = useEditry();
  const itemId = Number(item?.editryId);
  const editing = Boolean(overlayEnabled && adminSession?.token && Number.isInteger(itemId) && itemId > 0);

  if (!editing) {
    return children;
  }

  return (
    <EditableModel
      modelSlug={model}
      itemId={itemId}
      language={languageOf(item)}
      fieldKey={field}
      as={as}
      className={className}
      showFallbackWhileLoading={false}
      fallback={typeof children === 'string' ? children : undefined}
    />
  );
}
